import { render, staticRenderFns } from "./VaIconFree.vue?vue&type=template&id=02497324&"
import script from "./VaIconFree.vue?vue&type=script&lang=js&"
export * from "./VaIconFree.vue?vue&type=script&lang=js&"
import style0 from "./VaIconFree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports